import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import { useIsHandlerLoading } from 'hooks/useIsLoading';

import { RecipeErpViewComponentProps } from '../Index';
import * as State from '../State';

type IProps = RecipeErpViewComponentProps & {
	ingredientId: string;
};

export const ProductSearchInput = (props: IProps) => {
	const { t } = useTranslation();

	const [search, setSearch] = useState<string>('');
	const nrOfMatches: number = 3;

	const [isLoading, searchAndAddNewProductsToIngredient] = useIsHandlerLoading(() =>
		props.handlers.searchAndAddNewProductsToIngredient({
			ingredientId: props.ingredientId,
			searchTerm: search,
			nrOfMatches: nrOfMatches,
		})
	);

	const resetManuallySearchedProductsFromIngredient = () => {
		props.handlers.resetManuallySearchedProductsFromIngredient({
			ingredientId: props.ingredientId,
		});
		setSearch('');
	};

	const isButtonDisabled = (): boolean => {
		if (isLoading) return true;
		if (search.length === 0) {
			return !State.hasManuallySearchedProducts(props.state, {
				ingredientId: props.ingredientId,
			});
		}
		return false;
	};

	return (
		<div className="d-flex">
			<div className="input-group input-group-sm mb-3">
				<input
					className="form-control"
					onChange={(t) => {
						setSearch(t.currentTarget.value);
					}}
					placeholder={t('_general:INPUT_PLACEHOLDER_SEARCHTERM')}
					type="text"
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							searchAndAddNewProductsToIngredient();
						}
					}}
					value={search}
				/>
				<RenderIf
					condition={State.hasManuallySearchedProducts(props.state, {
						ingredientId: props.ingredientId,
					})}
				>
					<button
						className="btn btn-outline-danger advancedSearch btn-200"
						type="button"
						disabled={isLoading}
						onClick={resetManuallySearchedProductsFromIngredient}
					>
						{t('_general:RESET')}
					</button>
				</RenderIf>
				<button
					className="btn btn-outline-primary advancedSearch btn-200"
					type="button"
					disabled={isButtonDisabled()}
					onClick={searchAndAddNewProductsToIngredient}
				>
					{isLoading ? (
						<FontAwesomeIcon icon={faSpinner} spin />
					) : (
						t('_general:BTN_SEARCH')
					)}
				</button>
			</div>
		</div>
	);
};
